export const NO_PROFILE = '__none__';

/** Built-in starters carry a stable English `profile_name` for the API and a
 *  localized display name keyed by `builtin_key`. */
export const profileLabel = (p, t) => (p?.builtin_key
    ? t(`salesCalc.profiles.builtin.${p.builtin_key}`, p.profile_name)
    : (p?.profile_name || ''));

const ASSUMPTION_KEYS = [
    'value_per_review', 'sales_impact_pct_per_star',
    'negative_review_cost', 'assumed_negative_rate_pct',
];

/** True once the on-screen assumptions no longer match the loaded profile. */
export const profileDirty = (profile, values) => {
    if (!profile || !values) return false;
    if ((profile.currency || 'USD') !== (values.currency || 'USD')) return true;
    return ASSUMPTION_KEYS.some((k) => Number(profile[k] ?? 0) !== (parseFloat(values[k]) || 0));
};
